import { render, staticRenderFns } from "./LanguageChooser.vue?vue&type=template&id=0da631ba&scoped=true&"
import script from "./LanguageChooser.vue?vue&type=script&lang=ts&"
export * from "./LanguageChooser.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageChooser.vue?vue&type=style&index=0&id=0da631ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da631ba",
  null
  
)

export default component.exports